import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface ICustomParams {
    logo?: string;
    hideFilter?: boolean;
    hideMask?: boolean;
    hideMenus?: string[];
    hideMattingVip?: boolean;
    hideTextMenuContent?: boolean;
    hideTextMask?: boolean;
    hideAiText?: boolean;
    hideFeaturedPhotos?: boolean;
    hideFeedback?: boolean;
    feedbackText?: string;
    saveBtnText?: string;
    showSaveLocal?: boolean;
    defaultCollapse?: string;
    hideTextEffect?: boolean;
    textEffectFree?: boolean;
    mattingFree?: boolean;
    hideFolder?: boolean;
    hideAiRemoveVip?: boolean;
    removeFree?: boolean;
    showTemplateFilter?: boolean;
    hideTemplateCategory?: boolean;
    customSearch?: boolean;
    hideCreateCopy?: boolean;
    hideSizeVip?: boolean;
    hideSizeBack?: boolean;
    appBucket?: string;
    hideSizeExtension?: boolean;
    hideBackgroundLibrary?: boolean;
    hideAiEntrance?: boolean;
    [key: string]: any;
}

export interface ISdkModel {
    domainWhiteList: string[];
    setDomainWhiteList: (payload: string[]) => void;
    isInSDK: boolean;
    setIsInSDK: (payload: boolean) => void;
    customParams: ICustomParams;
    setCustomParams: (payload: ICustomParams) => void;
}

const useSdkModel = create<ISdkModel>()(
    immer((set) => ({
        domainWhiteList: [],
        setDomainWhiteList: (payload) =>
            set((state) => {
                state.domainWhiteList = payload;
            }),
        isInSDK: false,
        setIsInSDK: (payload) =>
            set((state) => {
                state.isInSDK = payload;
            }),
        customParams: {},
        setCustomParams: (payload) =>
            set((state) => {
                state.customParams = payload;
            }),
    })),
);

export { useSdkModel };
export const getSdkModel = () => useSdkModel.getState();
